import Icon from 'components/_UI/Icon'
import Text from 'components/_UI/Text'
import React from 'react'
import styled from 'styled-components'
import { FullyCentered } from 'styled/alignment/Center'
import { Column } from 'styled/alignment/Column'
import { Row } from 'styled/alignment/Row'
import colors from 'theme/colors'
import FinancialStatusIcon from '../status/FinancialStatusIcon'
import fonts from 'theme/fonts'
import currency from 'helpers/currency'
import date from 'helpers/date'
import time from 'helpers/time'
import { panelAccent, panelAccentAlpha } from 'theme/panelAccent';

export default function GeneralWithdraws({ withdraw }) {
    return (
        <Column>
            {withdraw?.length > 0 ? (
                withdraw?.map((el, index) => (
                    <React.Fragment key={el.id}>
                        <TransactionItem>
                            <Row style={{ alignItems: 'center' }}>
                                <FinancialStatusIcon status='withdraw' />
                                <TextInfoContent>
                                    <Text paddingBottom={0} color={colors.nightDark}>
                                        Saque para a conta bancária
                                    </Text>
                                    <Text paddingBottom={0} name='small' color={colors.night}>
                                        {`${date.format(el.created_at)} - ${time.getFormatedTime(el.created_at)}`}
                                    </Text>
                                </TextInfoContent>
                            </Row>

                            <PriceColumn>
                                <AmountText color={colors.primaryLight}>
                                    -{currency.format(el?.value)}
                                </AmountText>
                                <StatusBadge status='success'>
                                    Processado
                                </StatusBadge>
                            </PriceColumn>
                        </TransactionItem>
                        {index < withdraw.length - 1 && <Divider />}
                    </React.Fragment>
                ))
            ) : (
                <NotFoundContainer>
                    <PigIconContainer>
                        <Icon name='pig' color={panelAccent(colors.occasionalPurple)} />
                    </PigIconContainer>
                    <Text type='bold' name='normal' color={colors.nightDark} paddingBottom={'4px'}>
                        Nenhum saque realizado
                    </Text>
                    <Text textAlign='center' name='small' color={colors.night}>
                        Você ainda não efetuou nenhum saque. Verifique se possui algum valor disponível e faça o primeiro repasse para sua conta bancária.
                    </Text>
                </NotFoundContainer>
            )}
        </Column>
    )
}


const PigIconContainer = styled(FullyCentered)`
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: ${panelAccentAlpha(colors.occasionalPurple, '10')};
    margin-bottom: 12px;
`;

const NotFoundContainer = styled(FullyCentered)`
    flex-direction: column;
    padding: 40px 1.5em;
`;

const TextInfoContent = styled(Column)`
    width: auto;
`;

const TransactionItem = styled(Row)`
    padding: 14px 4px;
    justify-content: space-between;
    align-items: center;
    border-radius: 8px;
    transition: background 0.15s ease;

    &:hover {
        background: ${colors.neutral};
    }
`;

const Divider = styled.div`
    height: 1px;
    background: ${colors.neutralDark};
    margin: 0 4px;
`;

const PriceColumn = styled(Column)`
    width: auto;
    min-width: 120px;
    padding: 0 4px;
    text-align: right;
    align-items: flex-end;
`;

const AmountText = styled.span`
    font-size: 14px;
    font-weight: 600;
    color: ${({ color }) => color};
`;

const StatusBadge = styled.span`
    display: inline-block;
    padding: 3px 10px;
    margin-top: 4px;
    font-size: ${fonts.sizes.mini};
    font-weight: 600;
    border-radius: 50px;
    letter-spacing: 0.2px;

    ${({ status }) => status === 'pending' && `
        background: #FEF9C3;
        color: ${colors.occasionalOrange};
    `};

    ${({ status }) => status === 'success' && `
        background: #DCFCE7;
        color: ${colors.successDark};
    `};
`;
